import { render, staticRenderFns } from "./App2.vue?vue&type=template&id=15936d0b&"
import script from "./App2.vue?vue&type=script&lang=js&"
export * from "./App2.vue?vue&type=script&lang=js&"
import style0 from "./App2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports